import { createContext, useContext } from "react";
import { NO_ACTIVITY, type AgentActivity } from "./agentActivity";

export const AgentActivityContext = createContext<readonly AgentActivity[]>(NO_ACTIVITY);

export function useAgentActivity(): readonly AgentActivity[] {
  return useContext(AgentActivityContext);
}
